import { Config, createConfigPlugin } from "./config";
import { createHttpClientPlugin } from "./http-client";
import { createLoggerPlugin } from "./logger";

export type Sdk = ReturnType<typeof createSdkPlugin>;

export function createSdkPlugin(initialConfig: Config, version: string) {
  const configPlugin = createConfigPlugin(initialConfig);
  const logger = createLoggerPlugin(configPlugin);
  const http = createHttpClientPlugin(configPlugin, logger);

  return {
    ...configPlugin,
    http,
    logger,
    version,
  };
}
